import { useProjects } from '@servicetim/ui/api';
import { Page, PageHeader } from '@servicetim/ui/components';
import { useNavigate, useSearch } from '@tanstack/react-router';
import { AutomationsTable } from '@/features/automations/automations-table';
import { SimpleSelect } from '@/features/projects/ui/simple-select';

/** `/automations?project=<id>`: every rule the caller can see, optionally filtered to one project. */
export function AutomationsPage() {
  const { project } = useSearch({ strict: false });
  const navigate = useNavigate();
  const projects = useProjects({ pageSize: 200 });

  return (
    <Page>
      <PageHeader
        title="Automations"
        description="Trigger, conditions and actions run as declarative JSON (no scripting). Tenant-wide rules run for every project; a project's own rules also show on its Automations tab."
      />
      <div className="max-w-xs">
        <SimpleSelect
          aria-label="Filter by project"
          value={project}
          placeholder="Every project (and tenant-wide)"
          emptyLabel="Every project (and tenant-wide)"
          options={projects.items.map((p) => ({ value: p.id, label: `${p.key} · ${p.name}` }))}
          onChange={(next) =>
            void navigate({ to: '/automations', search: next ? { project: next } : {} })
          }
        />
      </div>
      <AutomationsTable filterProjectId={project} />
    </Page>
  );
}
